import Vue from 'vue'
import VueI18n from 'vue-i18n';
import App from './App.vue'
import * as posterProvider from './provider/posterProvider'
import * as smosterProvider from './provider/smosterProvider'
import { initSentry } from './util/initSentry'
import { init } from './util/i18n'
import { store } from './store/store'

initSentry('https://4f0fd6bd6ba04c248a72fec1d6f61290@sentry.io/5011134')

Vue.config.productionTip = false
Vue.prototype.$posterProvider = posterProvider
Vue.prototype.$smosterProvider = smosterProvider

// enable textarea resizing
var VueAutosize = require('vue-autosize')
Vue.use(VueAutosize)
Vue.use(VueI18n)

const app = new Vue({
  render: (h) => h(App),
  i18n: init(),
  store: store
})

app.$mount('#app')
